module.exports = __webpack_public_path__ + "img/icon-chat-blue-light.97245e7a.svg";